import { makeListState, STATUSES } from 'app/utils/redux';

import * as t from './types';

const initialState = {
  characters: makeListState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    // fetch notices
    case `${t.FETCH_CHARACTERS}_PENDING`:
      return {
        ...state,
        characters: {
          ...state.characters,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_CHARACTERS}_SUCCESS`:
      return {
        ...state,
        characters: {
          ...state.characters,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          list: action.payload.result,
        },
      };
    case `${t.FETCH_CHARACTERS}_ERROR`:
      return {
        ...state,
        characters: {
          ...state.characters,
          status: STATUSES.ERROR,
        },
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/front/characters/reducer.js